import axios from "axios";

const BACKEND_URL = "https://lucky-feather-34b5.smonlinesdstudios.workers.dev";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Interceptor to inject JWT tokens automatically using your existing key 'ch_token'
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ch_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Error Formatter Utility
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Named exports mapped to your endpoints for easy importing across components
export const projectService = {
  // Authentication / User Session Management
  login: (email, password) => api.post('/auth/login', { email, password }).then(res => res.data),
  register: (email, password, name) => api.post('/auth/register', { email, password, name }).then(res => res.data),
  getMe: () => api.get('/auth/me').then(res => res.data),
  logout: () => api.post('/auth/logout').then(res => res.data),

  // Projects & Workspace Operations
  listProjects: () => api.get('/projects').then(res => res.data),
  getProject: (id) => api.get(`/projects/${id}`).then(res => res.data),
  createProject: (name) => api.post('/projects', { name }).then(res => res.data),
  updateProject: (id, data) => api.patch(`/projects/${id}`, data).then(res => res.data),
  deleteProject: (id) => api.delete(`/projects/${id}`).then(res => res.data),
  publishProject: (id) => api.post(`/projects/${id}/publish`).then(res => res.data),

  // Assets Upload Engine
  uploadFile: async (file) => {
    const response = await api.post('/uploads', file, {
      headers: {
        'Content-Type': file.type,
      },
    });
    return response.data;
  },
  listUploads: () => api.get('/uploads').then(res => res.data),
};

export default api;
